"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'account.grades.free': 'Gratuito',
    'account.grades.free.description': 'Caratteristiche di base per iniziare',
    'account.grades.free.feature1': 'Uso mensile limitato',
    'account.grades.free.feature2': 'Modelli IA di base',
    'account.grades.free.feature3': 'Supporto della comunità',
    'account.grades.basic': 'Base',
    'account.grades.basic.description': 'Caratteristiche avanzate per utenti regolari',
    'account.grades.basic.feature1': 'Maggiore uso mensile',
    'account.grades.basic.feature2': 'Modelli IA standard',
    'account.grades.basic.feature3': 'Supporto via email',
    'account.grades.pro': 'Pro',
    'account.grades.pro.description': 'Caratteristiche avanzate per professionisti',
    'account.grades.pro.feature1': 'Alto uso mensile',
    'account.grades.pro.feature2': 'Modelli IA premium',
    'account.grades.pro.feature3': 'Supporto prioritario',
    'account.grades.ultra': 'Ultra',
    'account.grades.ultra.description': 'Caratteristiche massime per utenti esperti',
    'account.grades.ultra.feature1': 'Uso illimitato',
    'account.grades.ultra.feature2': 'Tutti i modelli IA',
    'account.grades.ultra.feature3': 'Supporto dedicato',
};
